/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiScenarioEntityType,
    InternalApiScenarioEntityTypeFromJSON,
    InternalApiScenarioEntityTypeToJSON,
    InternalApiScenarioMetric,
    InternalApiScenarioMetricFromJSON,
    InternalApiScenarioMetricToJSON,
    InternalApiScenarioStatus,
    InternalApiScenarioStatusFromJSON,
    InternalApiScenarioStatusToJSON,
    InternalApiScenarioTypeV2,
    InternalApiScenarioTypeV2FromJSON,
    InternalApiScenarioTypeV2ToJSON,
} from '../models';

export interface FindAllScenarioMetricsRequest {
    size: number;
    types: Array<InternalApiScenarioTypeV2>;
    statuses: Array<InternalApiScenarioStatus>;
    entityType?: InternalApiScenarioEntityType;
    categoryIds?: Array<string>;
    periodType?: FindAllScenarioMetricsPeriodTypeEnum;
}

export interface FindScenarioMetricsRequest {
    scenarioHandle: string;
    periodType?: FindScenarioMetricsPeriodTypeEnum;
}

/**
 * 
 */
export class ScenarioMetricsApi extends runtime.BaseAPI {

    /**
     * Fetches scenario metrics
     */
    async findAllScenarioMetricsRaw(requestParameters: FindAllScenarioMetricsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiScenarioMetric>>> {
        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling findAllScenarioMetrics.');
        }

        if (requestParameters.types === null || requestParameters.types === undefined) {
            throw new runtime.RequiredError('types','Required parameter requestParameters.types was null or undefined when calling findAllScenarioMetrics.');
        }

        if (requestParameters.statuses === null || requestParameters.statuses === undefined) {
            throw new runtime.RequiredError('statuses','Required parameter requestParameters.statuses was null or undefined when calling findAllScenarioMetrics.');
        }

        const queryParameters: any = {};

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.entityType !== undefined) {
            queryParameters['entityType'] = requestParameters.entityType;
        }

        if (requestParameters.types) {
            queryParameters['types'] = requestParameters.types;
        }

        if (requestParameters.statuses) {
            queryParameters['statuses'] = requestParameters.statuses;
        }

        if (requestParameters.categoryIds) {
            queryParameters['categoryIds'] = requestParameters.categoryIds;
        }

        if (requestParameters.periodType !== undefined) {
            queryParameters['periodType'] = requestParameters.periodType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/scenarios/metrics`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiScenarioMetricFromJSON));
    }

    /**
     * Fetches scenario metrics
     */
    async findAllScenarioMetrics(requestParameters: FindAllScenarioMetricsRequest, initOverrides?: RequestInit): Promise<Array<InternalApiScenarioMetric>> {
        const response = await this.findAllScenarioMetricsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches scenario metrics
     */
    async findScenarioMetricsRaw(requestParameters: FindScenarioMetricsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiScenarioMetric>> {
        if (requestParameters.scenarioHandle === null || requestParameters.scenarioHandle === undefined) {
            throw new runtime.RequiredError('scenarioHandle','Required parameter requestParameters.scenarioHandle was null or undefined when calling findScenarioMetrics.');
        }

        const queryParameters: any = {};

        if (requestParameters.periodType !== undefined) {
            queryParameters['periodType'] = requestParameters.periodType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/scenarios/metrics/{scenarioHandle}`.replace(`{${"scenarioHandle"}}`, encodeURIComponent(String(requestParameters.scenarioHandle))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiScenarioMetricFromJSON(jsonValue));
    }

    /**
     * Fetches scenario metrics
     */
    async findScenarioMetrics(requestParameters: FindScenarioMetricsRequest, initOverrides?: RequestInit): Promise<InternalApiScenarioMetric> {
        const response = await this.findScenarioMetricsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum FindAllScenarioMetricsPeriodTypeEnum {
    ONE_MONTH_BEFORE = 'ONE_MONTH_BEFORE',
    TWO_TO_FOUR_MONTHS_BEFORE = 'TWO_TO_FOUR_MONTHS_BEFORE'
}
/**
    * @export
    * @enum {string}
    */
export enum FindScenarioMetricsPeriodTypeEnum {
    ONE_MONTH_BEFORE = 'ONE_MONTH_BEFORE',
    TWO_TO_FOUR_MONTHS_BEFORE = 'TWO_TO_FOUR_MONTHS_BEFORE'
}
